export const paymentRejectType = new Map<string, string>([
    ["Definitive", "Definitivo"],
    ["Transitory", "Transitorio"]
]);